export default "\n<ul>\n    <li *ngFor=\"let post of posts\">\n        <a href=\"/landings/{{post.slug}}\">{{post.title.rendered}}</a>\n    </li>\n</ul>\n"